module.exports = __webpack_public_path__ + "static-portal/img/9.2b07e1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/9.jpg
// module id = pfBO
// module chunks = 4